/* ============================================================
   Savor Beauty — Carrot Rose CoQ-10 Serum landing page
   Offer switching, AJAX add-to-cart, click-to-play video,
   scroll reveals. No dependencies.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-lp-carrot-rose]');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- offer switcher ---------------------------------- */
  var variantInput = root.querySelector('[data-lp-variant]');
  var heroCta      = root.querySelector('#lp-cr-form [data-lp-cta]');
  var mirrorInput  = root.querySelector('[data-lp-variant-mirror]');
  var mirrorCta    = root.querySelector('[data-lp-cta-mirror]');

  root.querySelectorAll('input[name="lp-offer"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      if (variantInput) variantInput.value = radio.value;
      if (mirrorInput)  mirrorInput.value  = radio.value;
      var label = radio.getAttribute('data-label');
      if (label) {
        if (heroCta)   heroCta.textContent   = label;
        if (mirrorCta) mirrorCta.textContent = label;
      }
    });
  });

  /* ---------- add to cart -------------------------------------
     Stiletto's drawer is `.quick-cart__wrapper.active`, and its markup
     is re-rendered through Shopify's Section Rendering API. We read the
     section id from the DOM rather than hardcoding it, so a theme
     rebuild doesn't break this. If any part of that is missing we fall
     back to a plain navigation to /cart — the customer always ends up
     somewhere they can check out from.
  ------------------------------------------------------------- */
  var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';

  function quickCartSectionId() {
    var el = document.querySelector('[data-section-type="quick-cart"]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  var lastOpener = null;

  function closeQuickCart() {
    var wrapper = document.querySelector('.quick-cart__wrapper');
    if (!wrapper || !wrapper.classList.contains('active')) return;
    wrapper.classList.remove('active');
    document.documentElement.classList.remove('lp-cr-cart-open');
    if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    lastOpener = null;
  }

  /* Swapping the section's innerHTML destroys the theme's own listeners on the
     close button, so we delegate from document instead. Bound once, survives
     every re-render: the X, the overlay, and Escape all close the drawer. */
  document.addEventListener('click', function (event) {
    var wrapper = event.target.closest ? event.target.closest('.quick-cart__wrapper') : null;
    if (!wrapper) return;
    if (event.target.closest('[data-modal-close], .quick-cart__close-icon') ||
        event.target.classList.contains('quick-cart__overlay')) {
      event.preventDefault();
      closeQuickCart();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') closeQuickCart();
  });

  function openQuickCart(sectionHtml, sectionId) {
    if (sectionHtml && sectionId) {
      var host = document.getElementById('shopify-section-' + sectionId);
      if (host) host.innerHTML = sectionHtml;
    }
    var wrapper = document.querySelector('.quick-cart__wrapper');
    if (!wrapper) return false;
    wrapper.classList.add('active');
    document.documentElement.classList.add('lp-cr-cart-open');
    var focusTarget = wrapper.querySelector('[data-modal-close], .quick-cart__close-icon');
    if (focusTarget) focusTarget.focus();
    return true;
  }

  function refreshBagCount() {
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        root.querySelectorAll('[data-lp-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        });
        return c;
      })
      .catch(function () { return null; });
  }

  root.querySelectorAll('[data-lp-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('[data-lp-cta]');
      var errorEl = form.querySelector('[data-lp-error]');
      var original = button ? button.textContent : '';
      var sectionId = quickCartSectionId();

      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (button) { button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…'; }

      var payload = {
        items: [{ id: Number(form.querySelector('input[name="id"]').value), quantity: 1 }]
      };
      if (sectionId) payload.sections = sectionId;

      fetch(cartUrl + '/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Could not add to bag.');
            return data;
          });
        })
        .then(function (data) {
          refreshBagCount();
          var html = data.sections && sectionId ? data.sections[sectionId] : null;
          lastOpener = button;
          var opened = openQuickCart(html, sectionId);

          if (button) { button.textContent = 'Added ✓'; button.removeAttribute('aria-busy'); }
          setTimeout(function () { if (button) button.textContent = original; }, 2000);

          /* No drawer on this theme? Don't strand the customer. */
          if (!opened) window.location.href = cartUrl;
        })
        .catch(function (error) {
          if (button) { button.textContent = original; button.removeAttribute('aria-busy'); }
          if (errorEl) {
            errorEl.innerHTML = error.message + ' <a href="' + cartUrl + '">View bag</a>';
            errorEl.hidden = false;
          } else {
            form.submit();
          }
        });
    });
  });

  /* ---------- header button scrolls to the offer -------------- */
  root.querySelectorAll('[data-lp-scroll]').forEach(function (button) {
    button.addEventListener('click', function () {
      var target = document.querySelector(button.getAttribute('data-lp-scroll'));
      if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------- click-to-play video ------------------------------
     preload="none" keeps these off the critical path entirely —
     nothing downloads until someone actually taps a card.
  ------------------------------------------------------------- */
  root.querySelectorAll('[data-lp-video]').forEach(function (frame) {
    var video = frame.querySelector('video');
    if (!video) return;

    frame.addEventListener('click', function () {
      if (frame.classList.contains('is-playing')) {
        video.pause();
        frame.classList.remove('is-playing');
        return;
      }
      root.querySelectorAll('[data-lp-video].is-playing').forEach(function (other) {
        other.classList.remove('is-playing');
        var v = other.querySelector('video');
        if (v) v.pause();
      });
      video.muted = false;
      video.controls = true;
      frame.classList.add('is-playing');
      var playing = video.play();
      if (playing && playing.catch) {
        playing.catch(function () {
          /* Autoplay with sound was refused — fall back to muted. */
          video.muted = true;
          video.play();
        });
      }
    });

    video.addEventListener('ended', function () { frame.classList.remove('is-playing'); });
  });

  /* ---------- scroll reveals ----------------------------------- */
  var reveals = root.querySelectorAll('.lp-cr__rise');
  if (!('IntersectionObserver' in window) || reduced) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
  reveals.forEach(function (el) { observer.observe(el); });
})();
